import * as SplashScreen from 'expo-splash-screen';
import { en, es, fr, registerTranslation } from 'react-native-paper-dates';
import { AppProviders } from '@/core/AppProviders';

/**
 * Root layout for the Expo Router app.
 * Loads custom fonts before rendering the app on native platforms.
 * Handles the splash screen so fonts and translations are ready before the UI shows.
 * Uses a shared ThemeProvider that composes Tamagui and Paper.
 */
SplashScreen.preventAutoHideAsync();

registerTranslation('en', en);
registerTranslation('fr', fr);
registerTranslation('es', es);

export default function RootLayout(): React.ReactNode {
  return <AppProviders />;
}
